import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Logging, LogLevel, getBrowsingInfo } from '@vcd-ecm-ui/Common';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { LAUNCH_DARKLY_KEY } from './constants/constants';
import App from './components/App/App';

// Initialize the Logging
Logging.Initialize('VCD-ECM-UI:', LogLevel.Info);

Logging.Info('Version:', process && process.env ? process.env.VERSION : 'Unknown');

Logging.Info('Browsing:', getBrowsingInfo());

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: LAUNCH_DARKLY_KEY,
    user: {
      anonymous: true,
    },
  });
  ReactDOM.render(
    <LDProvider>
      <App />
    </LDProvider>,
    document.getElementById('vcd-ecm-app'),
  );
})();
